import { asSequence } from "sequency"

const isValidationErrors = e => {
	return Array.isArray(e)
	&& e.every(item => [
		"message",
		"field",
		"validation",
	].every(key => key in item));
};

const isDisplayableValidationError = error => {
	return ![
		"ENGINE_EXCEPTION",
	].includes(error.validation);
};

const isApiError = e => {
	return !!e
	&& typeof e == "object"
	&& ["status", "message"]
		.every(key => key in e);
};

const apiErrorHandler = ({ e, vm, commit }) => {
	if(isValidationErrors(e)){
		asSequence(e)
		.filter(isDisplayableValidationError)
		.forEach(error => commit("SET_ERROR", {
			key: error.field,
			value: error.message,
		}));
	}else if(isApiError(e)){
		vm.$toast.error(e.message);
	}else{
		vm.$toast.error("Oups, nous avons rencontré un problème");
	}

	throw e;
};

export {
	// isValidationErrors,
	// isApiError,
	apiErrorHandler,
}